var map = {
	"./basketball.webp": 1693,
	"./bti-img.webp": 1694,
	"./bti-title-cn.webp": 1695,
	"./bti-title-en.webp": 1696,
	"./cup.webp": 1697,
	"./football.webp": 1698,
	"./im-img.webp": 1699,
	"./im-title-cn.webp": 1700,
	"./im-title-en.webp": 1701,
	"./sb-img.webp": 1702,
	"./sb-title-cn.webp": 1703,
	"./sb-title-en.webp": 1704,
	"./sbo-img.webp": 1705,
	"./sbo-title-cn.webp": 1706,
	"./sbo-title-en.webp": 1707,
	"./sport-bg.webp": 1708,
	"./sport-ctg.webp": 1709
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 793;